<template>
  <BgImageLayout title="License terms labels" :page="__guide.licenseTermLabels" icon-color="white">
    <AgGridWrapper
      ref="wrapper"
      :options="options"
      :actions="actions"
      separator
      include-search-box
      needs-update-preprocessing
      @requested-update="updateRow"
      @refresh-data="getLabels"
      @show-modal="createDialog = true"
    />

    <CreateEditDialog v-model="createDialog" title="Create Label" @created="labelCreated" />

    <CreateEditDialog v-model="editDialog" :item-to-edit="itemToEdit" title="Edit Label" @updated="labelUpdated" />
  </BgImageLayout>
</template>

<script>
import * as apiTo from '@/modular-api'
import { dateRenderer, dateSorter } from '@lib/generic.utils'
// Components
import AgGridWrapper from '@components/ag-grid-helpers/AgGridWrapper'
import LmEntityActions from '@components/ag-grid-helpers/EntityActions'
import CreateEditDialog from './components/CreateEditDialog'
import { deleteAgGridRow } from '@/reusable/ConfirmationDialog/delete-ag-grid-row'

export default {
  components: {
    AgGridWrapper,
    CreateEditDialog
  },

  data() {
    return {
      createDialog: false,
      editDialog: false,
      itemToEdit: null,
      termLabels: null
    }
  },

  computed: {
    options() {
      return {
        rowData: this.termLabels,
        context: {
          actions: [
            {
              icon: 'pencil',
              tooltip: 'Edit',
              onClick: this.editRow,
              color: 'tertiary'
            },
            {
              icon: 'trash',
              tooltip: 'Delete',
              onClick: this.deleteAgGridRow,
              color: 'faded'
            }
          ]
        },
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            tooltipField: 'name',
            editable: true,
            cellRenderer: params => params.value
          },
          {
            headerName: 'Created',
            field: 'created_at',
            comparator: dateSorter,
            cellRenderer: params => dateRenderer(params.value),
            tooltipValueGetter: params => dateRenderer(params.value)
          },
          {
            headerName: 'Updated',
            field: 'updated_at',
            comparator: dateSorter,
            cellRenderer: params => dateRenderer(params.value),
            tooltipValueGetter: params => dateRenderer(params.value)
          },
          {
            headerName: 'Actions',
            cellRendererFramework: LmEntityActions
          }
        ]
      }
    },

    actions() {
      return [
        {
          label: 'Create New License Term Label',
          event: 'show-modal',
          type: 'button',
          color: 'tertiary',
          size: 'md'
        }
      ]
    }
  },

  created() {
    this.getLabels()
  },

  methods: {
    getLabels() {
      apiTo.GET_TERM_LABELS().then(({ data }) => (this.termLabels = data.result))
    },

    editRow({ data }) {
      this.itemToEdit = data
      this.editDialog = true
    },

    deleteAgGridRow(params) {
      deleteAgGridRow(params, 'GET_TERM_LABEL_CONFIRMATION', 'DELETE_TERM_LABEL', () => {
        const index = this.termLabels.findIndex(t => t.id === params.data.id)
        if (~index) this.termLabels.splice(index, 1)
      })
    },

    updateRow({ item }) {
      apiTo.MODIFY_TERM_LABEL(item.id, item).then(({ data }) => {
        const index = this.termLabels.findIndex(t => t.id === item.id)
        if (~index) this.termLabels.splice(index, 1, data.result)
      })
    },

    labelCreated(newLabel) {
      this.termLabels.push(newLabel)
    },

    labelUpdated(updatedLabel) {
      const index = this.termLabels.findIndex(t => t.id === updatedLabel.id)
      if (~index) this.termLabels.splice(index, 1, updatedLabel)
    }
  }
}
</script>
